module.exports = __webpack_public_path__ + "static/overlay-titles-do-414661ee6e225e00960d31f7cc3f6416.png";